// A linear scale (P3): a row of numbered buttons from `min` to `max`, with a
// word at each end. The answer is the number; pressing the chosen one again
// clears it. The group wrapper (label, error, role) is FieldInput's.
import type { FieldDefinition } from '../shared/types';
import { scaleRange, scaleValue } from './questionTypes';

export default function ScaleInput({ def, domId, value, onChange, disabled }: {
  def: FieldDefinition;
  domId: string;
  value: unknown;
  onChange: (v: unknown) => void;
  disabled?: boolean;
}) {
  const { min, max, minLabel, maxLabel } = scaleRange(def.ui_meta);
  const current = scaleValue(value);
  const steps = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  return (
    <div className="of-scale">
      <div className="of-scale-steps">
        {steps.map((n) => (
          <button
            key={n} type="button" id={`${domId}-${n}`} disabled={disabled}
            className={`of-scale-step${n === current ? ' on' : ''}`}
            role="radio" aria-checked={n === current}
            aria-label={`${n} of ${max}`}
            onClick={() => onChange(n === current ? '' : n)}
          >{n}</button>
        ))}
      </div>
      {(minLabel || maxLabel) && (
        // On a phone the steps are a 5-per-row grid, so "left word / right
        // word" stops lining up with the ends of the run: the number each
        // word belongs to is printed from `data-end` (form.css). An attribute
        // rather than text, so what this element SAYS is the same at every
        // width — the words are the author's, not "0 = ".
        <div className="of-scale-ends" aria-hidden="true">
          <span data-end={min}>{minLabel || ''}</span>
          <span data-end={max}>{maxLabel || ''}</span>
        </div>
      )}
    </div>
  );
}
